// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import echarts from 'echarts'
import axios from 'axios'
import ElementUI from 'element-ui'
import cons from '@/components/constant';
import 'element-ui/lib/theme-chalk/index.css'
// import JSONbig from 'json-bigint'



Vue.config.productionTip = false

Vue.prototype.echarts = echarts
Vue.prototype.axios = axios

// Vue.prototype.axios.defaults.transformResponse = [function (data) {
// 	// Do whatever you want to transform the data
//   d = JSONbig.parse(data);
//   console.log(d)
//   return d
// }]

// Add a request interceptor
Vue.prototype.axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
Vue.prototype.axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
  }, function (error) {
    console.log(error)
    ///////////////////////////////
    // console.log(error.config) //
    ///////////////////////////////
    if(error.response.status == 403 && error.response.data.message === 'Permission denied.'){
      // 重新登陆
      Vue.prototype.$message({
        type: 'error',
        message: '当前用户没有此权限!'
      });
    }


    if(error.response.status == 401){
      // 重新发送
      // alert(localStorage.refresh_token)
      var re_token = localStorage.refresh_token
      Vue.prototype.axios.put(cons.apis + '/v1_0/authorizations', {},{
          headers: {
            'Authorization': 'Bearer ' + re_token
          },
          responseType: 'json'
      }).then(dat=>{
        // console.log(dat.data.data.token)
        localStorage.token = dat.data.data.token

        //  刷新了token，重新请求
        error.config.headers.Authorization = 'Bearer '+localStorage.token
        return Vue.prototype.axios.request(error.config);

      }).catch(err=>{
        // console.log(111, err.response);
        // 刷新re_token过期
        if(err.response.status === 403 && err.response.data.message == 'Wrong refresh token.'){  //
          // 重新登陆
          Vue.prototype.$message({
            type: 'error',
            message: '登陆超时，请重新登陆!'
          });

          // 路由到登陆页面
          console.log(this)
          vm.$router.push({path:'/'});
        }
      })
    }
    // Do something with response error
    return Promise.reject(error);
});




Vue.use(ElementUI);


/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js